import { AddClubAdminRequestRequest, RemoveClubAdminRequestRequest } from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from './queries';
import { SSF } from '~/apis/api';

export function useCreateClubAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: AddClubAdminRequestRequest }) =>
      SSF.api.clubsAddClubAdminCreate(id, payload),
    onSuccess: (_, { id }) => client.invalidateQueries({ queryKey: keys.list(id) }),
  });
}

export function useDeleteClubAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: RemoveClubAdminRequestRequest }) =>
      SSF.api.clubsRemoveClubAdminCreate(id, payload),
    onSuccess: (_, { id }) => client.invalidateQueries({ queryKey: keys.list(id) }),
  });
}
